import React, { useEffect } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import PublicPageHeader from '../../components/landing/PublicPageHeader';
import ColourLibraryContent, {
  COLOUR_LIBRARY_COUNT,
} from '../../components/shared/ColourLibraryContent';

const PublicExploreColoursScreen = () => {
  const { colors } = useTheme();

  useEffect(() => {
    if (Platform.OS !== 'web') return;
    document.title = 'Colour Library — ColourSense';
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(
        `meta[name="${name}"]`
      ) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    const setOg = (property: string, content: string) => {
      let el = document.querySelector(
        `meta[property="${property}"]`
      ) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta(
      'description',
      `Browse ${COLOUR_LIBRARY_COUNT}+ curated colour palettes inspired by Sanzo Wada. Tap any swatch to instantly copy its hex code.`
    );
    setMeta(
      'keywords',
      'colour palette, hex codes, colour combinations, colour library, seasonal colours, Sanzo Wada, Japanese colour aesthetics'
    );
    setOg('og:title', 'Colour Library — ColourSense');
    setOg(
      'og:description',
      'Explore curated colour palettes and copy hex codes in one tap.'
    );
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]}>
      <PublicPageHeader activeScreen="explore-colours" />
      <ColourLibraryContent />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default PublicExploreColoursScreen;
